import React from 'react'
import { Box, Grid } from '@mui/material'
import CalCustomTitleBar from './common/CalCustomTitleBar'
import ShowValues from './common/ShowValues'

const CalTermCharges = React.memo(({ allValues }) => {
  const { termsCharges = 0 } = allValues

  return (
    <Box>
      <CalCustomTitleBar title={"Term Charges"} />

      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        mb={"20px"}
        spacing={3}
        direction="row"
      >
        <Grid item xs={12} sm={12}>
          <ShowValues
            label={"Term Charges"}
            value={termsCharges?.toFixed(2)}
          />
        </Grid>
      </Grid>
    </Box>
  )
})

export default CalTermCharges